import { render, staticRenderFns } from "./FormService.vue?vue&type=template&id=182ff627"
import script from "./FormService.vue?vue&type=script&lang=js"
export * from "./FormService.vue?vue&type=script&lang=js"
import style0 from "./FormService.vue?vue&type=style&index=0&id=182ff627&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports